import { Bleed } from 'braid-design-system';
import React from 'react';

import PackagesPage from 'src/views/PackagesPage/PackagesPage';

const ProductsTab = () => (
  <Bleed horizontal="xlarge" top="xlarge" bottom="large">
    <PackagesPage />
  </Bleed>
);

export default ProductsTab;
